import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\GetModelNotificationByIdController::__invoke
* @see app/Http/Controllers/ModelNotification/GetModelNotificationByIdController.php
* @route '/api/model-notification/{model_notification}'
*/
const GetModelNotificationByIdController = (args: { model_notification: string | number | { id: string | number } } | [model_notification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetModelNotificationByIdController.url(args, options),
    method: 'get',
})

GetModelNotificationByIdController.definition = {
    methods: ["get","head"],
    url: '/api/model-notification/{model_notification}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ModelNotification\GetModelNotificationByIdController::__invoke
* @see app/Http/Controllers/ModelNotification/GetModelNotificationByIdController.php
* @route '/api/model-notification/{model_notification}'
*/
GetModelNotificationByIdController.url = (args: { model_notification: string | number | { id: string | number } } | [model_notification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { model_notification: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { model_notification: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            model_notification: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        model_notification: typeof args.model_notification === 'object'
        ? args.model_notification.id
        : args.model_notification,
    }

    return GetModelNotificationByIdController.definition.url
            .replace('{model_notification}', parsedArgs.model_notification.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\GetModelNotificationByIdController::__invoke
* @see app/Http/Controllers/ModelNotification/GetModelNotificationByIdController.php
* @route '/api/model-notification/{model_notification}'
*/
GetModelNotificationByIdController.get = (args: { model_notification: string | number | { id: string | number } } | [model_notification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetModelNotificationByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ModelNotification\GetModelNotificationByIdController::__invoke
* @see app/Http/Controllers/ModelNotification/GetModelNotificationByIdController.php
* @route '/api/model-notification/{model_notification}'
*/
GetModelNotificationByIdController.head = (args: { model_notification: string | number | { id: string | number } } | [model_notification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetModelNotificationByIdController.url(args, options),
    method: 'head',
})

export default GetModelNotificationByIdController